import { useQuery } from "@tanstack/react-query";
import { fetchAllSeries } from "../api/fetchAllSeries";

export const useAllSeries = (body, enabled = true) => {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["allSeries", body],
    queryFn: () => fetchAllSeries(body),
    enabled: !!body && enabled,
  });

  return {
    data: data?.result || null,
    error,
    isLoading: isLoading || isFetching,
    refetch,
  };
};

